import { ref } from "vue";
import { addRequest, destroyRequest, getAllRequests, requestSearch} from "@/api/requests";


const state = {
    requests:ref([]),

};

const actions = {
    async fetchRequests({commit} , page){
        try{
            const response = await getAllRequests(page);
            console.log(response);
            commit('SET_REQUESTS' , response.data.requests);
        }catch(e){
            throw new Error(e);
        }
    },
    async searchRequests({commit} , data){
        try{
            const response = await requestSearch(data);
            console.log(response);
            commit('SET_REQUESTS' , response.data.requests);
        }catch(e){
            throw new Error(e);
        }
    },
    async addNewRequest({commit} , data){
        try{
            const response = await addRequest(data);
            console.log(response);
            commit('ADD_REQUEST' , response);
        }catch(e){
            throw new Error(e);
        }
    },
    async deleteRequest({commit} , id){
        try{
            const response = await destroyRequest(id);
            commit('DELETE_REQUEST' , id);
        }catch(e){
            throw new Error(e);
        }
    }
}

const mutations = {
    UPDATE_UNIT(state , updatedunit){
        state.units.data.map((unit,index) => unit.id == updatedunit.id ? state.units.data[index] = updatedunit : null);
    },
    DELETE_REQUEST(state , id){
        state.requests.data = state.requests.data.filter(request => request.id !== id);
    },
    SET_LISTS(state, lists){
        state.lists = lists;
    },
    SET_REQUESTS(state , requests){
        state.requests = requests;
        state.requests.data = state.requests.data.map(request => ({
            ...request,
            is_REQUEST_show:false,
            is_edit_active:false,
            is_filter_opens:false,
        }))
    },
    ADD_REQUEST(state , request){
        state.requests.data.unshift({
            ...request,
            is_REQUEST_show:false,
            is_edit_active:false,
        });
    }
};
const getters = {
    getRequests: (state) => state.requests,
};

export default {
    namespaced: true,
    state , 
    getters,
    mutations,
    actions
};